/** @jsxImportSource @emotion/react */
import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiPageTemplate,
} from "@inscopix/ideas-eui";
import { DataTableContent } from "./layout/DataTableContent";
import { DataTableHeader } from "./layout/DataTableHeader";
import { DataTableMenuBar } from "./layout/DataTableMenuBar";
import { DataTableQuickActionBar } from "./layout/DataTableQuickActionBar/DataTableQuickActionBar";
import { memo } from "react";
import { DataTableBottomBar } from "./layout/DataTableBottomBar";
import { DataTableTooltipProvider } from "./layout/DataTableTooltip";
import { DataTableDragDropProvider } from "./layout/DataTableDragDropProvider";
import { css } from "@emotion/react";
import {
  useSetCurrentPage,
  useTourStep,
} from "providers/TourProvider/TourProvider.hooks";
import { useDataTableContext } from "./store/DataTableProvider";

export const PageProjectDataTable = memo(function PageProjectDataTable() {
  const selectedTableKind = useDataTableContext((s) => {
    const { selectedTableId, tables } = s;
    return tables.find((table) => table.id === selectedTableId)?.kind;
  });
  useSetCurrentPage(
    selectedTableKind === "data" ? "projectDataTable" : "projectAnalysisTable",
  );

  const { component: TourDataTableUploadFiles2, anchorId } = useTourStep(
    "TourDataTableUploadFiles",
    2,
  );

  return (
    <EuiPageTemplate
      css={css`
        height: 100%;
      `}
      mainProps={{
        css: css`
          overflow: auto;
          max-block-size: calc(100vh - var(--euiFixedHeadersOffset, 0));
        `,
      }}
      // prevents this from switching to responsive layout
      responsive={[]}
    >
      <DataTableDragDropProvider>
        <DataTableTooltipProvider>
          <EuiFlexGroup
            direction="column"
            gutterSize="none"
            style={{ height: "100%", overflow: "hidden" }}
          >
            <EuiFlexItem
              grow={false}
              style={{ paddingLeft: 10, paddingRight: 10 }}
            >
              <DataTableHeader />
            </EuiFlexItem>

            <EuiFlexItem
              grow={false}
              style={{ paddingLeft: 5, paddingRight: 5 }}
              id={anchorId}
            >
              <DataTableMenuBar />
              {TourDataTableUploadFiles2}
            </EuiFlexItem>

            <EuiFlexItem
              grow={false}
              style={{ paddingLeft: 5, paddingRight: 5 }}
            >
              <EuiHorizontalRule margin="none" />
              <DataTableQuickActionBar />
            </EuiFlexItem>

            <EuiFlexItem style={{ minHeight: 0 }}>
              <DataTableContent />
            </EuiFlexItem>
          </EuiFlexGroup>
          <DataTableBottomBar />
        </DataTableTooltipProvider>
      </DataTableDragDropProvider>
    </EuiPageTemplate>
  );
});
